import { RULE_TYPE_MAP } from '../config';
// 操作符转换的配置
const COMPARE_RULE = {
  is: {
    operatorType: 'none',
    operand: '==',
  },
  not: {
    operatorType: 'unary',
    operatorProp: 'bool',
    operand: '==',
  },
  gt: {
    operatorType: 'none',
    operand: 'range',
    formatterOutput(value) {
      return {
        gt: value.startValue,
      };
    },
    formatterInput(value) {
      return {
        startValue: value.gt,
      };
    },
  },
  lt: {
    operatorType: 'none',
    operand: 'range',
    formatterOutput(value) {
      return {
        lt: value.startValue,
      };
    },
    formatterInput(value) {
      return {
        startValue: value.lt,
      };
    },
  },
  gte: {
    operatorType: 'none',
    operand: 'range',
    formatterOutput(value) {
      return {
        gte: value.startValue,
      };
    },
    formatterInput(value) {
      return {
        startValue: value.gte,
      };
    },
  },
  lte: {
    operatorType: 'none',
    operand: 'range',
    formatterOutput(value) {
      return {
        lte: value.startValue,
      };
    },
    formatterInput(value) {
      return {
        startValue: value.lte,
      };
    },
  },
  between: {
    operatorType: 'unary',
    operatorProp: 'bool',
    operand: 'range',
    formatterOutput(value) {
      return {
        gt: value.startValue,
        lt: value.endValue,
      };
    },
    formatterInput(value) {
      return {
        startValue: value.gt,
        endValue: value.lt,
      };
    },
  },
  include: {
    operatorType: 'none',
    operand: 'include',
    formatterOutput(value) {
      return {
        all: value,
      };
    },
    formatterInput(value) {
      return value.all;
    },
  },
  'not-include': {
    operatorType: 'none',
    operand: 'include',
    formatterOutput(value) {
      return {
        one: value,
      };
    },
    formatterInput(value) {
      return value.one;
    },
  },
};

function getCompareByOperand(item) {
  let result = {};
  switch (item.operand) {
  case '==':
    result = COMPARE_RULE.is;
    break;
  case 'include':
    result = COMPARE_RULE.include;
    break;
  case 'range': {
    const itemValue = item.value;
    const { lt, gt, lte, gte } = itemValue;
    let flag = false;
    if (lt) {
      result = COMPARE_RULE.lt;
      flag = true;
    }
    if (gt) {
      if (flag) {
        result = COMPARE_RULE.between;
      } else {
        result = COMPARE_RULE.gt;
      }
    }

    flag = !!result;

    if (!flag) {
      if (lte) {
        result = COMPARE_RULE.lte;
        flag = true;
      }
      if (gte) {
        if (flag) {
          // 没有这个逻辑
        } else {
          result = COMPARE_RULE.gte;
        }
      }
    }
    break;
  }
  default:
        // no code
  }
  return result;
}

export const generatorRuleOptionsMap = function (ruleOptions) {
  const optionsMap = {};
  ruleOptions.forEach((item) => {
    if (item.children) {
      Object.assign(optionsMap, generatorRuleOptionsMap(item.children));
    } else {
      optionsMap[item.value] = item;
    }
  });
  return optionsMap;
};

/**
 * 将目标数据源转换为组件底层值
 * Todo
 * [x] 字段名到组件名的转换
 * [x] 分组递归
 * [x] not逻辑
 * [x] 复合组件的转换
 * [ ] 简单的数据校验，用来查错
 */
function getBaseItemFromThemis(originData, ruleOptionsMap) {
  const compareRule = getCompareByOperand(originData);
  const item = {
    componentName: ruleOptionsMap[originData.field].componentName,
    info: ruleOptionsMap[originData.field],
    value: {
      value: compareRule.formatterInput ? compareRule.formatterInput(originData.value) : originData.value,
      operand: originData.operand,
    },
  };
  return item;
}

export const ruleConvertToBase = function (originData, ruleOptionsMap, parentNode) {
  const formatData = {};
  const { metadata } = originData;
  let ruleList = [];
  let logicList = [];
  // 用来判断当前的节点是不是单目运算符组件
  const isUnaryItem = metadata.operatorType && metadata.operatorType === 'unary';
  // 用来判断当前的节点是不是复杂运算组件
  const isComponentItem = metadata.operatorType && metadata.operatorType === 'component';
  if (originData.type === 'unit' || isUnaryItem || isComponentItem) {
    // 获取当前操作符的配置
    let item = {};
    if (isUnaryItem) {
      const unaryData = originData.filter[0];
      item = getBaseItemFromThemis(unaryData, ruleOptionsMap);
      // 不是
      if (item.value.operand === '==' && originData[metadata.operatorProp] === 'not') {
        item.value.operand = 'not';
      }
      // 不包含
      if (item.value.operand === 'include' && originData[metadata.operatorProp] === 'not') {
        item.value.operand = 'not-include';
      }
    } else if (isComponentItem) {
      // isComponentItem code
      item = {
        componentName: ruleOptionsMap[originData.field].componentName,
        info: ruleOptionsMap[originData.field],
      };
      const { filter } = originData;
      const componentRuleList = [];
      const componentLogicList = [];
      filter.forEach((componentItem, index) => {
        const compareRule = getCompareByOperand(componentItem);
        componentRuleList.push({
          value: compareRule.formatterInput
            ? compareRule.formatterInput(componentItem.value)
            : componentItem.value,
          operand: componentItem.operand,
        });
        if (index < filter.length - 1) {
          componentLogicList.push('and');
        }
      });
      item.value = {
        ruleList: componentRuleList,
        logicList: componentLogicList,
      };
    } else {
      item = getBaseItemFromThemis(originData, ruleOptionsMap);
    }
    // 如果一个分组里面只有一个规则，将规则格式化成一个组
    if (metadata && metadata.alone) {
      formatData.nodeDeep = 2;
    } else {
      formatData.type = 'component';
    }
    // 如果没有父级元素说明整个规则只有一个元素，补充空节点保证规则出现在正确的位置
    if (!parentNode) {
      ruleList = [
        {
          ruleList: [item],
          logicList: [],
        },
      ];
    } else {
      ruleList.push(item);
    }
  } else if (originData.type === 'group' && originData.filter) {
    // 分组元素
    formatData.nodeDeep = metadata.nodeDeep;
    originData.filter.forEach((item, index) => {
      // 递归获取节点
      let newNode = ruleConvertToBase(item, ruleOptionsMap, originData);
      // 插入操作符，这里操作符插入是倒序的和规则元素不一样
      if (index < originData.filter.length - 1) {
        logicList.push(originData.bool);
      }
      // 临时规则观察使用情况
      if (newNode.metadata && newNode.metadata.alone) {
        console.log('newNode.metadata && newNode.metadata.alone 逻辑进入');
        newNode = {
          ruleList: [newNode],
          logicList: [],
        };
      }
      // 当前交互层只有两层，所以这里不做递归去处理了
      if (
      // 当获得的新节点和当前节点同级时
        newNode.nodeDeep === formatData.nodeDeep
                // 当获得的新节点是组件时，且当前节点是第二层时
                // 这里如果是通用的情况的时候，应该是将组件节点写到最深层，届时可能需要获取当前规则的最深是那一层
                || (newNode.type === 'component' && formatData.nodeDeep === 2)
      ) {
        ruleList = ruleList.concat(newNode.ruleList);
        logicList = newNode.logicList.concat(logicList);
      } else if (
      // 这里判断逻辑可以简化，但是为了容易懂就不再简化了
      // 当获得的新节点在非顶层，而当前节点在顶层时
        (newNode.nodeDeep === 2 && formatData.nodeDeep === 1)
                // 当获得的新节点是组件时，且当前节点是顶层时
                || (newNode.type === 'component' && formatData.nodeDeep === 1)
      ) {
        ruleList.push(newNode);
      }
    });
  }
  formatData.ruleList = ruleList;
  formatData.logicList = logicList;
  return formatData;
};

/**
 * 转换成Themis引擎
 * 对接人 @jakili
 * 数据逻辑是一个后序遍历
 * Todo
 * [x] 规则元素内部分组情况
 * [x] 分组递归
 * [x] not逻辑
 * [ ] 数据校验
 * [ ] 异常抛出
 */
export const ruleConvertToThemis = function (originData, nodeDeep = 1) {
  let formatData = {};
  const { ruleList } = originData;
  const { logicList } = originData;
  // 为了让相连的同一个逻辑放在一个filter里面，缓存当前逻辑
  let cacheLogic = '';

  // 根据一个元素生成一个节点
  function getNode(item, parentDeep = 1, parentRuleList) {
    // Todo 这里的数据如果出错需要抛一个树型结构错误
    const { value } = item;
    let newNode = {
      metadata: {},
    };
    if (item.componentName && item.value) {
      const componentTypeConfig = RULE_TYPE_MAP[item.componentName];
      const { fieldType } = componentTypeConfig;
      if (typeof fieldType === 'number') {
        const operandOptions = COMPARE_RULE[value.operand];
        newNode = {
          type: 'unit',
          operand: operandOptions.operand,
          field: item.info.value,
          fieldType,
          metadata: {},
        };
        if (operandOptions.formatterOutput) {
          newNode.value = operandOptions.formatterOutput(value.value);
        } else {
          newNode.value = value.value;
        }
        // 如果是弹幕运算符需要单独处理
        if (operandOptions.operatorType === 'unary') {
          newNode = {
            type: 'group',
            filter: [newNode],
            metadata: {},
          };
          newNode[operandOptions.operatorProp] = value.operand;
          newNode.metadata.operatorType = operandOptions.operatorType;
          newNode.metadata.operatorProp = operandOptions.operatorProp;
        }
      }
      if (typeof fieldType === 'object' && fieldType.length) {
        let componentRuleList = [];
        const filter = [];
        try {
          componentRuleList = item.value.ruleList;
        } catch (err) {
          // no code
        }
        componentRuleList.forEach((componentRuleItem, index) => {
          const operandOptions = COMPARE_RULE[componentRuleItem.operand];
          filter.push({
            type: 'component-unit',
            operand: operandOptions.operand,
            field: componentTypeConfig.fieldList[index],
            fieldType: fieldType[index],
            value: componentRuleItem.value,
            metadata: {},
          });
        });
        // 当前为了简单，假设了复杂组件之间的逻辑只有and关系
        newNode = {
          type: 'group',
          bool: 'and',
          metadata: {
            operatorType: 'component',
          },
          filter,
        };
      }
    } else if (item.ruleList && item.ruleList.length > 0) {
      newNode = ruleConvertToThemis(item, parentDeep + 1);
    }
    // 因为转化树的时候会移除空节点，所以如果父级的列表只有一个元素，标记该元素自成一组
    if (parentRuleList.length === 1) {
      newNode.metadata.alone = true;
    }
    return newNode;
  }
  ruleList.forEach((item, index) => {
    // 逻辑下标比内容下标少1
    const logicIndex = index - 1;
    if (index === 0) {
      // 当下标为0时，只插入一个子node
      formatData = getNode(item, nodeDeep, ruleList);
    } else if (cacheLogic === logicList[logicIndex]) {
      // 如果当前逻辑和缓存的逻辑相同，则直接在当前逻辑下的filter插入这个Node
      formatData.filter.push(getNode(item, nodeDeep, ruleList));
    } else {
      // 如果当前逻辑和缓存逻辑不同，则建立一个新的组，并将缓存的组当做子内容当做第一个元素放入filter
      cacheLogic = logicList[logicIndex];
      const newNode = {
        type: 'group',
        metadata: {
          nodeDeep,
        },
        bool: cacheLogic,
        filter: [formatData],
      };
      newNode.filter.push(getNode(item, nodeDeep, ruleList));
      formatData = newNode;
    }
  });
  return formatData;
};
export const getRuleData = function (ruleList) {
  const rule = { fieldConditionList: [] };
  rule.relation = ruleList.logic || 'and';
  if (ruleList.children) {
    ruleList.children.forEach((grp) => {
      const subRule = { fieldConditionList: grp.ruleList.map(item => item.ruleData) };
      if (grp.logic) {
        subRule.relation = grp.logic;
      }
      rule.fieldConditionList.push(subRule);
    });
  }
  return rule;
};
